'use client';

import { Content } from '@prismicio/client';
import { FC, useRef, useState } from 'react';
import { Simplify } from '../../../../../prismicio-types';

import { useVisible } from '@/hooks';

import { ArrowDown } from '@/assets';
import styles from './styles.module.scss';

type Props = {
  item: Simplify<Content.QuestionsAnswersSliceDefaultPrimaryQuestionsItem>;
  index: number;
};

export const Answer: FC<Props> = ({ item, index }) => {
  const [isVisibleQuestion, questionId] = useVisible();
  const answerRef = useRef<HTMLDivElement>(null);
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const isOpen = activeIndex === index;

  const handleAnswerClick = (answerIndex: number) => {
    setActiveIndex((prevIndex) =>
      prevIndex === answerIndex ? null : answerIndex
    );
  };

  return (
    <li
      id={questionId}
      className={`${styles.wrapper} ${isVisibleQuestion ? styles.isVisible : ''}`}
      style={{ transitionDelay: `${index * 0.13}s !important` }}
    >
      <button
        type="button"
        className={`${styles.questionContainer} ${isOpen ? styles.active : ''}`}
        onClick={() => handleAnswerClick(index)}
      >
        <p className={styles.question}>{item.question}</p>
        <div className={`${styles.arrow} ${isOpen ? styles.active : ''}`}>
          <ArrowDown />
        </div>
      </button>

      <div
        ref={answerRef}
        className={`${styles.answerContainer} ${isOpen ? styles.open : ''}`}
        style={
          isOpen
            ? {
                // eslint-disable-next-line react-hooks/refs
                height: answerRef.current?.scrollHeight
                  ? // eslint-disable-next-line react-hooks/refs
                    answerRef.current.scrollHeight + 5
                  : 0,
              }
            : { height: '0px' }
        }
      >
        <p className={styles.answer}>{item.answer}</p>
      </div>
    </li>
  );
};
